var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"languages-info__languages"},_vm._l((_vm.props.languages),function(language){return _c('div',{key:language,staticClass:"languages-info__language",attrs:{"data-lang":language,"title":language}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }